import React from "react";
import info from '../../assets/icons/info.svg';
import { Tooltip } from '@airdao/ui-library';

type RangeProps = {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
}

const Range = ({ label, value, onChange, min, max }: RangeProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(+e.target.value);
  };

  return (
    <div className="range">
      <span className="create-bond__bottom__title">
        {label}
        <Tooltip message="Maximum portion of the bond sellable within 24 hours.">
          <img src={info} alt="tooltip" />
        </Tooltip>
      </span>
      <input type="range" min={min} max={max} className="range__input" value={value} onChange={handleChange}/>
      <div className="range__legend">
        <span>{min} hour</span>
        <span>{max} hours</span>
      </div>
    </div>
  )
};

export default Range;
